import { WfRequest } from './../../models/request';
import { PagingService } from './../../../../../shared/Services/PagingService';
import { QueryModel } from './../../../../../shared/Models/queryModel';
import { RequestService } from './../../services/request.service';
import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { PagingModel } from '../../../../../shared/Models/PagingModel';
import { NbDialogService, NbWindowService, NbToastrService, NbDialogRef } from '@nebular/theme';
import { FollowRequestComponent } from '../follow-request/follow-request.component';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-follow-requests',
  templateUrl: './follow-requests.component.html',
  styleUrls: ['./follow-requests.component.scss'],
})
export class FollowRequestsComponent implements OnInit {
  @ViewChild('contentTemplate', { static: false }) contentTemplate: TemplateRef<any>;
  @ViewChild('okcontentTemplate', { static: false }) okcontentTemplate: TemplateRef<any>;
  @ViewChild('efadacontentTemplate', { static: false }) efadacontentTemplate: TemplateRef<any>;

  queryModel: QueryModel;
  finishLoading = false;
  componentModel: PagingModel;
  saved = false;
  item: WfRequest;
  selectedItem: WfRequest = {} as WfRequest;
  userComment: string;
  okuserComment: string = '';
  nouserComment: string = '';
  windowRf: any;
  flgAction: boolean = false;
  constructor(
    private service: RequestService,
    private paging: PagingService,
    // private dialogService: NbDialogService,
    private windowService: NbWindowService,
    private toastrService: NbToastrService,
    private ref: NbDialogRef<FollowRequestsComponent>
  ) {
    this.queryModel = new QueryModel();
  }

  ngOnInit() {
    this.componentModel = new PagingModel();
    //  this.loadFollowRequests();
  }
  loadFollowRequests() {
    this.service.getAllFollowedRequests(this.queryModel).subscribe((data) => {
      this.componentModel.responseObj = data.result;
      this.componentModel.responseData = data;
      this.componentModel.totalPages = data.totalPages;
      this.componentModel.pager = Array.from({ length: data.totalPages }, (v, k) => k + 1);
      //  this.componentModel.pager.slice(this.componentModel.currentPage - 1, this.componentModel.currentPage + 9);

      this.finishLoading = true;
    });
  }
  Detail(id: number, unitTypeId: number, criteriaType: number, title: string) {
    // if(unitTypeId === 1){ this.dialogService.open() }
    // if(unitTypeId === 2){ this.dialogService.open() }
    // if(unitTypeId === 1){ this.dialogService.open() }
  }
  follow(item: any[], isComplete: boolean) {
    // this.dialogService.open(FollowRequestComponent, { context: { item: item, complete: isComplete } });
  }
  setPage(page: number) {
    this.finishLoading = false;
    //   this.paging.setPage(page, this.componentModel, this.service, '/FollowRequests');
    this.finishLoading = true;
  }
  allowDecision(formId) {
    console.log(formId.event);

    this.item.currentPhaseAppliedFormId = +formId.event;

    this.service.put(this.item.id, this.item).subscribe();
    this.saved = true;
  }

  makeDecision(item: WfRequest, flgAction: number, formId = 0) {
    this.flgAction = false;
    this.selectedItem = item;
    // this.selectedItem.actionUserId = this.service.userId;
    this.selectedItem.flgAction = flgAction;
    this.userComment = '';
    if (flgAction === 1) {
      this.windowRf = this.windowService.open(this.okcontentTemplate, {
        title: 'اتخاذ القرار',
      });
    } else if (flgAction === 2) {
      this.windowRf = this.windowService.open(this.contentTemplate, {
        title: 'اتخاذ القرار',
      });
    }
    else if (flgAction === 4) {
      this.windowRf = this.windowService.open(this.contentTemplate, {
        title: 'اتخاذ القرار',
      });
    }
    else if (flgAction === 6) {
      if (formId == 0 || formId == null) {
        this.windowRf = this.windowService.open(this.efadacontentTemplate, {
          title: 'الإفادة',
        });
      } else {
        this.saveDecision(6);
      }
    }
    this.windowRf.onClose.subscribe((res) => {
      this.okuserComment = '';
      this.nouserComment = '';
      if (!this.flgAction) this.toastrService.show('لم يتم حفظ القرار', '');
      else {
        this.ref.close();
        this.ngOnInit();
      }
    });
    // .onClose.subscribe(res => {
    //   this.toastrService.show('لم يتم حفظ القرار', '');
    // });
    // item.actionUserId = this.service.userId;
    // item.flgAction = flgAction;
    // this.service.setDecision(item).subscribe();
  }

  saveDecision(status) {
    console.log('save deci');

    this.flgAction = true;
    if (this.okuserComment !== '') {
      this.selectedItem.comment = this.okuserComment;
    } else {
      this.selectedItem.comment = this.nouserComment;
    }
    this.service.setDecision(this.selectedItem).subscribe((res) => {
      if (status != null && status == 6) {
        this.toastrService.show('تم حفظ القرار بنجاح', '');
        this.ref.close('true');
      } else {
        this.windowRf.close();
        this.ref.close('true');
        this.toastrService.show('تم حفظ القرار بنجاح', '');
      }
    });
  }
  close() {
    this.ref.close('false');
  }
}
